import(/* webpackMode: "eager", webpackExports: ["LoginPageComponent"] */ "/home/runner/work/nextjs-ims/nextjs-ims/app/(routes)/login/_component/page-component/component.tsx");
